import React from "react";

export const UiDashboardEmptyMessage = (props) => {
  return (
    <>
      <div className="df-empty-screen-db">
        <div className={props?.className}>
          <img src={props?.icon} className="df-empty-screen-db__img" />
          <p className="df-empty-screen-db__para">{props?.message}</p>
          {props?.children}
        </div>
      </div>
    </>
  );
};

export const UiActivitiesEmptyMessage = (props) => {
  return (
    <>
      <div className="df-activities-sec">
        <div className=" mb-2">
          <p className="df-activities-sec__title">{props?.title}</p>

          <div className="df-activities-sec__empty">
            <img src={props?.emptyIcon} />
            <p className="mb-1 df-empty-title"> No transactions to display.</p>

            <p>
              Your activity history will appear here once you make a
              transaction.
            </p>
          </div>
        </div>
      </div>
    </>
  );
};
